/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DocumentResponseBase,
  ModuleFormAnswer,
} from '../models/index';
import {
    DocumentResponseBaseFromJSON,
    DocumentResponseBaseToJSON,
    ModuleFormAnswerFromJSON,
    ModuleFormAnswerToJSON,
} from '../models/index';

export interface DownloadOverviewRequest {
    contentId?: number;
}

export interface SaveToDocumentsRequest {
    contentId?: number;
}

export interface UpdateModuleFormRequest {
    nodeId?: number;
    moduleName?: string;
    columnCount?: string;
    moduleFormAnswer?: ModuleFormAnswer;
}

/**
 * 
 */
export class ModuleFormApi extends runtime.BaseAPI {

    /**
     */
    async downloadOverviewRaw(requestParameters: DownloadOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.contentId !== undefined) {
            queryParameters['contentId'] = requestParameters.contentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/ModuleFormApi/DownloadOverview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async downloadOverview(requestParameters: DownloadOverviewRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.downloadOverviewRaw(requestParameters, initOverrides);
    }

    /**
     */
    async saveToDocumentsRaw(requestParameters: SaveToDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentResponseBase>> {
        const queryParameters: any = {};

        if (requestParameters.contentId !== undefined) {
            queryParameters['contentId'] = requestParameters.contentId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/ModuleFormApi/SaveToDocuments`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentResponseBaseFromJSON(jsonValue));
    }

    /**
     */
    async saveToDocuments(requestParameters: SaveToDocumentsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentResponseBase> {
        const response = await this.saveToDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateModuleFormRaw(requestParameters: UpdateModuleFormRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.nodeId !== undefined) {
            queryParameters['nodeId'] = requestParameters.nodeId;
        }

        if (requestParameters.moduleName !== undefined) {
            queryParameters['moduleName'] = requestParameters.moduleName;
        }

        if (requestParameters.columnCount !== undefined) {
            queryParameters['columnCount'] = requestParameters.columnCount;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/ModuleFormApi/UpdateModuleForm`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ModuleFormAnswerToJSON(requestParameters.moduleFormAnswer),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async updateModuleForm(requestParameters: UpdateModuleFormRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.updateModuleFormRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
